import styled from "styled-components";

export const Main = styled.div`
   width: 600px;
   max-height: 80vh;
   overflow: auto;

   > .title {
      display: flex;
      align-items: center;

      .icon {
         display: flex;
         align-items: center;
         justify-content: center;
         width: 60px;
         height: 60px;
         background-color: rgb(250, 250, 250);
         border: 1px solid rgb(232, 232, 236);
         border-radius: 5px;
         margin-right: 20px;
         font-size: 25px;
      }
      h3 {
         font-weight: 500;
      }
      p {
         opacity: 0.8;
         margin-top: 3px;
      }
   }

   .picker {
      display: flex;
      gap: 15px;
      margin-top: 20px;
   }

   .empty {
      margin-top: 20px;
      padding: 25px;
      text-align: center;
      opacity: 0.6;
      background-color: rgb(243, 244, 246);
      border-radius: 5px;
   }

   .field {
      margin-top: 20px;

      label {
         display: block;
         font-size: 15px;
         opacity: 0.75;
         margin-bottom: 7.5px;
      }
      .row {
         display: flex;
         gap: 7.5px;

         input {
            flex: 1;
            height: 40px;
            border-radius: 8px;
            border: 1px solid rgb(200, 200, 200);
            padding: 0 12px;
            font-size: 15px;
         }
         button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 8px;
            border: 1px solid rgb(200, 200, 200);
            background-color: #fff;
            cursor: pointer;
            transition: all .2s ease-in-out;

            &:hover { background-color: rgb(243, 244, 246); }
         }
      }
   }

   .guideTabs {
      display: flex;
      gap: 7.5px;
      flex-wrap: wrap;
      margin-bottom: 10px;

      button {
         padding: 6px 14px;
         border-radius: 6px;
         border: 1px solid rgb(200, 200, 200);
         background-color: #fff;
         font-size: 14px;
         cursor: pointer;
         transition: all .2s ease-in-out;

         &.active {
            background-color: #1E272E;
            color: #fff;
            border-color: #1E272E;
         }
         &:hover:not(.active) { background-color: rgb(243, 244, 246); }
      }
   }

   .guideText {
      font-size: 13px;
      opacity: 0.7;
      margin: 7.5px 0;
      line-height: 1.5;
   }

   .code {
      display: flex;
      flex-direction: column;
      border-radius: 5px;
      overflow: hidden;

      .codeTitle {
         display: flex;
         align-items: center;
         justify-content: space-between;
         background-color: rgb(31, 41, 55);
         color: #eee;
         height: 36px;
         font-size: 14px;
         padding: 0 10px 0 16px;

         .copy {
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 2.5px 10px;
            border-radius: 5px;
            transition: all .2s ease-in-out;

            &:hover { background-color: #2e3d52; }
         }
      }
      pre {
         margin: 0 !important;
         font-size: 13px;
         max-height: 180px;
      }
   }
`;
